class Corpse extends PIXI.Sprite {
	frames: number;
	zombie: boolean = false;

	constructor(tex: PIXI.Texture, frames: number = 120) {
		super(tex);
		this.frames = frames;
	}

	update(delta: number) {
		this.frames -= delta;
		if (this.frames < 0) {
			this.zombie = true;
		}
	}
}